import { mapActions } from 'vuex'
import checkLoginMixin from '@/mixins/checkLoginMixin'

export default {
  mixins: [checkLoginMixin],
  methods: {
    ...mapActions({
      loadAreas: 'goods/loadAreas',
      loadPropertyDefinition: 'goods/loadPropertyDefinition'
    }),
    async readyGoodsSearch(condition) {
      await this.$refs.goodsSearch.init(condition)
    },
  }
}
